export default {
    settingsKeyFob_add: "Crear nuevo llavero",
    settingsKeyFobs_createTitle:"Crear nuevo Llavero",
    settingsKeyFobs_editTitle:"Editar Llavero",
    settingsKeyFobs_columTitle:"Llavero ",
    settingsKeyFobs_columTitleDriver:"Conductor ",
    settingsKeyFobs_minLengthMessage:'El campo debe contener un mínimo de caracteres: ',
    settingsKeyFobs_maxLengthMessage:'El campo debe contener un maximo de caracteres: ',
    settingsKeyFobs_success:'Llavero Guardado',
    settingsKeyFobs_deleteWarning:'¿Está seguro de que desea eliminar el Llavero?',
    settingsKeyFobs_deleteTitle:'Eliminar Llavero',
    settingsKeyFobs_deleted:'Llavero eliminado',
    settingsKeyFob_search:'Buscar por Llavero y Conductor',
    settingsKeyFobs_driverTitle:'Conductor',
    settingsKeyFobs_infoBluetooth:'Los IDs de los llaveros Bluetooth de Geometris no se pueden editar'
};